import * as _tslib2 from "tslib";

var _tslib = "default" in _tslib2 ? _tslib2.default : _tslib2;

import * as _safeJsonUtils2 from "safe-json-utils";

var _safeJsonUtils = "default" in _safeJsonUtils2 ? _safeJsonUtils2.default : _safeJsonUtils2;

import _localStorage from "./lib/localStorage";
import _shared from "../shared";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyValueStorage = void 0;
const tslib_1 = _tslib;
const safe_json_utils_1 = _safeJsonUtils;

const localStorage_1 = tslib_1.__importDefault(_localStorage);

const shared_1 = _shared;

class KeyValueStorage {
  constructor() {
    this.localStorage = localStorage_1.default;
  }

  getKeys() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return Object.keys(this.localStorage);
    });
  }

  getEntries() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return Object.entries(this.localStorage).map(shared_1.parseEntry);
    });
  }

  getItem(key) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const item = this.localStorage.getItem(key);

      if (item === null) {
        return undefined;
      }

      return safe_json_utils_1.safeJsonParse(item);
    });
  }

  setItem(key, value) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      this.localStorage.setItem(key, safe_json_utils_1.safeJsonStringify(value));
    });
  }

  removeItem(key) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      this.localStorage.removeItem(key);
    });
  }

}

exports.KeyValueStorage = KeyValueStorage;
exports.default = KeyValueStorage; //# sourceMappingURL=index.js.map

export default exports;
export const __esModule = exports.__esModule;
const _KeyValueStorage = exports.KeyValueStorage;
export { _KeyValueStorage as KeyValueStorage };